<template lang="html">
  <div class="card">
    <div class="left">
      <img
        :src="imageURL"
        alt="Image"
        data-aos="fade-up"
        data-aos-duration="1000"
      />
    </div>
    <div class="right">
      <h6 class="title" data-aos="fade-left" data-aos-duration="1000">
        {{ title }}
      </h6>
      <p class="description" data-aos="fade-left" data-aos-duration="1300">
        {{ description }}
      </p>
      <router-link :to="getFormattedLink()" class="link-route">
        <Button variant="link">{{
          buttonText
        }}</Button>
      </router-link>
    </div>
  </div>
</template>
<script>
import Button from "../General/Button.vue";
export default {
  props: {
    imageURL: String,
    title: String,
    description: String,
    buttonText: String,
    route: String,
    id: Number,
    categories: Array,
  },
  components: {
    Button,
  },
  methods: {
    escapeQuestionMark(text) {
      return text.replace(/\?/g, '%3F');
    },

    getFormattedLink() {
      if(this.categories.length>1) return this.route;
      const category = this.categories[0];
      const escapedTitle = this.escapeQuestionMark(category.title);
      return `/${this.route}/${escapedTitle}?id=${category.id}`;
    },
  },
};
</script>
<style lang="css" scoped>
.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  border: none;
}
.card .left {
  /* height: 220px; */
  width: 100%;
}
.card .left img {
  /* height: 100%; */
  width: 100%;
}
.card .right {
  margin-left: 15px;
  min-width: 200px;
}
.card .right .title {
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 42px;
  color: #33647e;
  margin-bottom: 20px;
}
.card .right .description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #585858;
  margin-bottom: 20px;
}
@media (max-width: 1200px) {
  .card .right {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .card .right .title {
    font-size: 24px;
    line-height: 29px;
    text-align: center;
  }
  .card .right .description {
    font-size: 16px;
    line-height: 19px;
    text-align: center;
  }
}
@media (max-width: 998px) {
  .card {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 40px;
  }
  .card .left {
    order: 2;
    width: 100%;
    height: auto;
  }
  .card .left img {
    width: 100%;
    height: auto;
  }
  .card .right {
    margin: 0;
    margin-bottom: 30px;
  }
}
.link-route {
  text-decoration: none;
}
</style>
